<template>
    <div class="row">
        <div class="col-12">
            <div class="row tit_page">
				<div class="col-12">
					<div class="float-left">
						<h1>Central de cobranças</h1>
					</div>
					<div class="back float-right">
						<a @click="$router.go(-1)"><span><img src="/static/assets/images/ico-back.svg"> Voltar</span></a>
					</div>
				</div>
            </div>
            <hr class="divider">

            <div class="row">
                <div class="col-12 col-md-9 info-business">
                    <div :class="'d-flex business align-items-center ' + 'status-' + abreviaStatus(solicitacao.StatusAtraso)"> 
                        <h3>{{ solicitacao.NomeEmpresa }}</h3>
                        <router-link :to="'/investimentos/historico/historico-de-investimento/' + reserva._id" class="btn btn-sm btn-primary">Ver solicitação</router-link>
                        <span><strong>Status:</strong> {{ formataStatus(solicitacao.StatusAtraso) }}</span>
                    </div>   
                    <p>
                        <span class="cnpj">CNPJ: {{ formatarCnpj(solicitacao.Cnpj) }}</span>
                        <span>{{ formataEmprestimo(solicitacao.TipoEmprestimo) }}</span>
                    </p>
                </div>
                <div :class="'col-12 col-md-3 text-left text-md-right align-self-end mt-2 rating rating-' + abreviaStatus(solicitacao.StatusAtraso)">
                    <strong class="d-flex justify-content-md-end align-items-center">
                        Score da operação <span :class="'circle ' + 'score-' + formatarScore(solicitacao.Score)"></span> {{ solicitacao.Score }}
                    </strong>
                </div>
            </div>

            <div class="row mt-2" v-if="regua === true">
                <div class="col-12">
                    <div class="regua-cobranca rounded">
                        <div class="row align-items-center">
                            <div class="col-12 col-md-4 col-lg-3">
                                <h4>Régua de cobrança</h4>
                            </div>
                            <div class="col-12 col-md-8 col-lg-9">
                                <div class="container-progress">
                                    <div class="point left active">
                                        <span class="point-bullet" data-toggle="tooltip" data-placement="top" title="Pagamentos em dia"><i></i></span>
                                        <span class="text">0</span>
                                    </div>
                                    <div :class="'point point-15 ' + isActive(15, solicitacao.DataVencimento)">
                                        <span class="point-bullet" data-toggle="tooltip" data-placement="top" title="Negativado"><i></i></span>
                                        <span class="text">15</span>
                                    </div>
                                    <div :class="'point point-30 ' + isActive(30, solicitacao.DataVencimento)">
                                        <span class="point-bullet" data-toggle="tooltip" data-placement="top" title="Protesto"><i></i></span>
                                        <span class="text">30</span>
                                    </div>
                                    <div :class="'point point-60 ' + isActive(60, solicitacao.DataVencimento)">
                                        <span class="point-bullet" data-toggle="tooltip" data-placement="top" title="Processo judicial"><i></i></span>
                                        <span class="text">60</span>
                                    </div>
                                    <div :class="'point point-90 ' + isActive(90, solicitacao.DataVencimento)">
                                        <span class="point-bullet" data-toggle="tooltip" data-placement="top" title="Processo judicial em andamento"><i></i></span>
                                        <span class="text">90</span>
                                    </div>
                                    <div :class="'point right ' + isActive(120, solicitacao.DataVencimento)">
                                        <span class="point-bullet" data-toggle="tooltip" data-placement="top" title="Processo judicial em andamento"><i></i></span>
                                        <span class="text">+120</span>
                                    </div>
                                    <div class="progress">
                                        <div class="amount" >
                                             <div class="amount-indicator" :style="'width: ' + formatarPorcentagem(solicitacao.DataVencimento) + '%'"/>

                                             </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="divider">

            <div class="row" v-if="notificacoes.length > 0">
                <div class="col-12">
                    <div class="item" v-for="notificacao in notificacoes" :key="notificacao">
                        <div class="row">
                            <div class="col-12">
                                <h5>Parcela {{ parseInt(solicitacao.ParcelasAtrasadas) }} de {{ solicitacao.Informacoes.Prazo }} : Vencido desde {{ formataData(solicitacao.DataVencimento) }}</h5>
                            </div>
                        </div>
                        <hr class="divider">
                        <div class="row">
                            <div class="col-12 col-md-10">
                                <strong>Notificação:</strong>
                            </div>
                            <div class="col-12">
                                <strong>{{ formataData(notificacao.Updated) }} - {{ notificacao.Titulo }}</strong>
                                <p v-html="notificacao.Mensagem"></p>
                            </div>
                        </div>
                        <br>
                        <div class="row" v-if="notificacao.Documento">
                            <div class="col-12">
                                <strong>Documentos anexados:</strong>
                            </div>
                            <div class="col-12 col-md-16" v-for="doc in notificacao.Documento" :key="doc">
                                <ul>
                                    <li class="d-flex align-items-center">
                                        <img src="/static/assets/images/ico-pdf.png" alt="Icone pdf">
                                        <a @click="abrirDoc(doc.TokenAzure)">{{ doc.NomeArquivo }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row align-items-center info" v-else>
                <div class="col-12 d-flex flex-column justify-content-center">
                    <div class="text-center">
                        <h5 v-if="solicitacao.StatusAtraso == 'Emdia'">O empréstimo dessa empresa está em dia até o momento.</h5>
                        <h5 v-else-if="notificacoes.length == 0">Não há notificações sobre recebíveis desta empresa até o momento.</h5>
                        <a @click="$router.go(-1)" class="btn btn-outline-secondary">
                            <span><img src="/static/assets/images/ico-back.svg"> Voltar página</span>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    // CODIGOS DE STATUS
    // ed - em dia
    // 15 - 15dias de atraso
    // 30 - 30 dias de atraso
    // 60 - 60 dias de atraso
    // m60 - mais de 60 dias
    // ngt - negativado
    // cej - cobranca extra judicial
    // cj - cobranca judicial
    // rng - renegociada

    import CentralService from '../services/api/centralCobranca';
    import ReservaInvestimento from '../services/api/reservaInvestimento';

    import Masker from '@/utils/masker'
    import * as mutationTypes from '@/store/mutation-types.js';

    export default {
        data() {
            return {
                regua: true,
                solicitacaoID: '',
                id: '',
                investidor: {},
                solicitacao: {},
                reserva: {},
                notificacoes: []
            }
        },
        methods: {
            abrirDoc(doc) {

                window.open(process.env.HUB_URL + "/file/" + doc)
            },
            async solicitacaoProcesso() {

                const {data} = await CentralService.GetDetalheSolicitacaoProcesso(this.solicitacaoID);

                console.log("data --> ", data);

                if (data) {

                    this.solicitacao = data;
                }  
            },
            async notificacoesProcesso() {

                const {data} = await CentralService.GetDetalheNotificacoesProcesso(this.solicitacaoID);

                console.log("notificacao --> ", data);

                if (data) {

                    this.notificacoes = data;
                }  
            },
            async reservaId() {

                const {data} = await ReservaInvestimento.GetReservaId(this.solicitacaoID);

                console.log("Reserva --> ", data);

                if (data) {

                    this.reserva = data;
                }  
            },
            abreviaStatus(status) {

                switch(status) {
                    case "Emdia":
                        return 'ed';
                    case "15 dias":
                        return "15";
                    case "Negativado":
                        return "ngt";
                    case "Protesto":
                        return "pto";
                    case "Cobrancaextrajudicial":
                        return "cej";
                    case "Cobrancajudicial":
                        return "cj";    
                    case "Renegociada":
                        return "rng";
                }
            },
            formataStatus(status) {

                switch(status) {
                    case "Emdia":
                        return 'Em dia';
                    case "15 dias":
                        return "1 a 15 dias";
                    case "Negativado":
                        return "Negativado";
                    case "Protesto":
                        return "Protesto";
                    case "Cobrancaextrajudicial":
                        return "Cobrança extrajudicial";
                    case "Cobrancajudicial":
                        return "Cobrança judicial";    
                    case "Renegociada":
                        return "Renegociada";
                }
            },
            formatarScore(score) {

                if(score == null)
                    return "-";

                if(score.length > 1 && !isNaN(score[1])) {
                    return score[0];
                }

                return score == ""?"-":score;
            },
            formatarAtraso(dataVenc) {         
                if(dataVenc == '0001-01-02T00:00:00Z') {
                    return 0;
                }
                    
                let dataHoje = new Date();
                let vencimento = new Date(dataVenc);
                let atraso, diff;

                if(vencimento == null || vencimento > dataHoje) {
                    atraso = 0;
                } else {
                    diff = Math.abs(dataHoje.getTime() - vencimento.getTime());
                    atraso = Math.ceil(diff / (1000 * 3600 * 24));
                }

                return atraso;
            },
            formatarPorcentagem(dataVenc) {
            
                let dataHoje = new Date();
                let vencimento = new Date(dataVenc);
                let atraso, diff, porcentagem;

                if(dataVenc == '0001-01-02T00:00:00Z' || vencimento == null || vencimento > dataHoje) {
                    porcentagem = 100;
                } else {

                    diff = Math.abs(dataHoje.getTime() - vencimento.getTime());
                    atraso = Math.ceil(diff / (1000 * 3600 * 24));

                    porcentagem = 100 - (atraso * 100) / 120;
                }
                return porcentagem;
            },
            isActive(valor, dataVenc) {

                let atraso = this.formatarAtraso(dataVenc);

                if(valor <= atraso) 
                    return 'active';
            },
            formataEmprestimo(tipo) {

                if (tipo == "emprestimo-ccb") {
				    return "Empréstimo CCB"
                }
                if (tipo == "emprestimo-coletivo") {
                    return "Empréstimo Coletivo"
                }

                if( tipo == "emprestimo-de-impacto" || tipo == "emprestimo-de-impacto2") {
                    return "Empréstimo de Impacto"
                }

                if (tipo == "veiculo-em-garantia") {
                    return "Empréstimo com Garantia Veicular"
                }

                if (tipo == "imovel-em-garantia") {
                    return "Empréstimo com Garantia Imobiliária"
                }
                
                if (tipo == "antecipacao-recebiveis") {
                    return "Antecipação de Recebíveis"
                }
            },
            formatarCnpj(cnpj) {

                return Masker.maskCnpj(cnpj)
            },
            formataData(date) {

                let spliter = date.split("T")
                let newDate = spliter[0].split('-')
                let time = spliter[1].split(':')

                return `${newDate[2]}/${newDate[1]}/${newDate[0]}`
            },

            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/central-de-cobranca/status-cobranca',
                    title: 'VisualizarStatusCobranca',
                })
            },
        },
        async created(){

            this.$store.commit(mutationTypes.START_LOADING)

            this.solicitacaoID = this.$route.query.id;

            await this.solicitacaoProcesso();
            await this.notificacoesProcesso();
            await this.reservaId();

            this.$store.commit(mutationTypes.STOP_LOADING);

            //tagueamento GA
            await this.taggingGA();
        },
    }
</script>

<style lang="scss" scoped>
    .divider.force {
        border:1px solid rgba(0, 0, 0, 0.05)!important
    }
    .tit_page {
        .back {
            a {
                span {
                    display: flex;
                    
                    img {
                        width: 8px;
                        margin-right: 8px;
                    }
                }
            }
        }
    }

    .rating {
        font-weight: normal;
        color: #888888;

        .circle {
            width: 24px;
            height: 24px;
            margin: 0 5px;
        }
    }

    .status {
        &-ed {
            .btn-primary {
                background-color: #6FC30E;
                border-color: #6FC30E;

                &:hover {
                    background-color: darken(#6FC30E, 5%);
                    border-color: darken(#6FC30E, 5%);
                }
            }
            
        }
        &-15 {
            .btn-primary {
                background-color: #FFA700;
                border-color:#FFA700;

                &:hover {
                    background-color: darken(#FFA700, 5%);
                    border-color: darken(#FFA700, 5%);
                }
            }
        }
        &-30 {
            .btn-primary {
                background-color: #FF3100;
                border-color:#FF3100;

                &:hover {
                    background-color: darken(#FF3100, 5%);
                    border-color: darken(#FF3100, 5%);
                }
            }
        }
        &-60 {
            .btn-primary {
                background-color: #D92D04;
                border-color:#D92D04;

                &:hover {
                    background-color: darken(#D92D04, 5%);
                    border-color: darken(#D92D04, 5%);
                }
            }
        }
        &-m60 {
            .btn-primary {
                background-color: #981D00;
                border-color:#981D00;

                &:hover {
                    background-color: darken(#981D00, 5%);
                    border-color: darken(#981D00, 5%);
                }
            }
        }
        &-ngt {
            .btn-primary {
                background-color: #FF4500;
                border-color:#FF4500;

                &:hover {
                    background-color: darken(#FF4500, 5%);
                    border-color: darken(#FF4500, 5%);
                }
            }
        } 
        &-pto {
            .btn-primary {
                background-color: #FF0010;
                border-color:#FF0010;

                &:hover {
                    background-color: darken(#FF0010, 5%);
                    border-color: darken(#FF0010, 5%);
                }
            }
        }                    
        &-cej {
            .btn-primary {
                background-color: #8B0000;
                border-color:#8B0000;

                &:hover {
                    background-color: darken(#8B0000, 5%);
                    border-color: darken(#8B0000, 5%);
                }
            }
        }
        &-cj {
            .btn-primary {
                background-color: #5B0000;
                border-color:#5B0000;

                &:hover {
                    background-color: darken(#5B0000, 5%);
                    border-color: darken(#5B0000, 5%);
                }
            }
        }
        &-rng {
            .btn-primary {
                background-color: #41D3BD;
                border-color:#41D3BD;

                &:hover {
                    background-color: darken(#41D3BD, 5%);
                    border-color: darken(#41D3BD, 5%);
                }
            }
        }
    }

    .info {
        height: 400px;
        
        h5 {
            color: #999999;
            padding-bottom: 20px;
            font-weight: normal;
            font-size: 30px;
        }

        .btn {
            font-weight: bold;
            text-transform: uppercase;
            
            span {
                display: flex;
                align-items: center;
            }
            
            img {
                width: 10px;
                margin-right: 10px;
            }
        }
    }

    .info-business {
        h3 {
            font-size: 30px;
            font-weight: normal;
        }

        p {
            padding:0px;
            margin:0px;
        }

        span {
            font-size: 18px;
            color: #999999;
            display: block;

            &.cnpj {
                color: #000;
                font-size: 20px;
            }
        }

        .business {
            .btn {
                margin: 0 8px;
                padding-left: 15px;
                padding-right: 15px;
                text-transform: uppercase;
                font-weight: bold;
                font-size: 12px;
            }
            span {
                font-size: 18px;
                color: #000;
            }
        }
    }

    .regua-cobranca {
        margin-top: 5px;
        background: #f7f7f7;
        border: 1px solid #DDDDDD;
        padding: 20px 40px;

        .container-progress {
        margin:20px 10px;
        position: relative;
        
        .point {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content:center;
            position:absolute;
            z-index: 2;
            top: -5px;
            
            &-bullet {
                display:flex;
                align-items: center;
                justify-content:center;
                text-align: center;
                background: #fff;
                border-radius:1em;
                width: 22px;
                height: 22px;
                box-shadow: 0px 0px 5px rgba(0,0,0,0.50);
                
                i {
                    display:block;
                    background: #999;
                    height: 12px;
                    width: 12px;
                    border-radius:1em;
                }
            }
            
            .text {
                font-size: 12px;
                font-weight: bold;
            }
            
            &.left {
                left:-6px;
                
                &.active {
                    i {
                    background: #6FC30E;
                    }
                }
                &:hover {
                    i {
                    background: #6FC30E;
                    }
                }
            }
            
            &.right {
                right:-10px;
                
                &.active {
                    i {
                    background: #0863A4;
                    }
                }
                &:hover {
                    i {
                    background: #0863A4;
                    }
                }
            }
            
            &-15 {
                left: 12.5%;
                
                &.active {
                    i {
                    background: #FFA800;
                    }
                }
                &:hover {
                    i {
                    background: #FFA800;
                    }
                }
            }
            
            &-30 {
                left: 25%;
                
                &.active {
                    i {
                    background: #FF2E00;
                    }
                }
                &:hover {
                    i {
                    background: #FF2E00;
                    }
                }  
            }
            
            &-60 {
                left: 50%;
                
                &.active {
                    i {
                    background: #DC2B00;
                    }
                }
                &:hover {
                    i {
                    background: #DC2B00;
                    }
                }
            }
            
            &-90 {
                left:75%;
                
                &.active {
                    i {
                    background: #9A1B00;
                    }
                }
                &:hover {
                    i {
                    background: #9A1B00;
                    }
                }
            }
        }
        
        .progress {
            background: lightgray;
            height: 12px;
            border-radius: 1em;

            .amount {

                &-indicator {

                    background: radial-gradient(circle at left, transparent 10px, lightgray 10px);
                    height: 12px;
                }
                display: flex;
                flex-direction: row-reverse;
                height: 12px;
                border-radius: 1em;
                width: 100%;
                background: linear-gradient(
                    to right,
                    #6FC30E 0%,
                    #FFA800 8%,
                    #FFA800 15%,
                    #FFA800 18%,
                    #FF2E00 25%,
                    #DC2B00 55%,
                    #9A1B00 67.5%,
                    #9A1B00 85%,
                    #0863A4 100%) !important;
                }
            }
        }
    }

    .item {
        border-radius: 5px;
        border: 1px solid #ddd;
        border-left: 5px solid #D92D04;
        padding: 25px;
        margin-bottom: 25px;

        h5 {
            padding-bottom: 5px;
        }

        p {
            margin:0px;
            padding:0px;
            color: #999;
        }

        ul {
            padding:0px;
            margin:0px;
        }

        img {
            width: 25px;
            margin-right: 8px;
        }

        a {
            color: #999;
            font-size: 14px;

            &:hover {
                color: #666;
            }
        }
    }

    span {
        &.circle {
            display: block;
            width: 20px;
            height: 20px;
            border-radius: 1em;
        }

        &.status {
            &-ed {
                background-color: #6FC30E;
            }
            &-15 {
                background-color: #FFA700;
            }
            &-ngt {
                background-color: #FF4500;
            }
            &-pto {

                background-color: #FF0010;
            }
            &-cej {
                background-color: #8B0000;
            }  
            &-cj {
                background-color: #5B0000;
            }                        
            &-rng {
                background-color: #41D3BD;
            }
        }

        &.score {
            &-AA {
                background-color: #C1CF2E;
            }
            &-A {
                background-color: #2DC2BF; 
            }
            &-B {
                background-color: #6FC30D;
            }
            &-C {
                background-color: #F04887;
            }
            &-D {
                background-color: #FFB928;
            }
            &-E {
                background-color: #FD615D;
            }
            &-HR {
                background-color: #B61843;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/views/CentralCobrancaView.vue